<template>
    <card>
        <card-body>

            <template-chat-form ref="modalForm" @reload="getTemplates"></template-chat-form>

            <button class="btn btn-primary tw-float-right" @click="create()">
                <i class="fa fa-plus"></i> New Template
            </button>

            <v-client-table ref="table" :data="templates" :columns="columns" :options="options">
                <template slot="locations" slot-scope="props">
                    <span v-for="(location, index) in props.row.locations" :key="`location-${index}`">
                        <span v-if="index > 0">, </span>
                        {{ location.name }}
                    </span>
                </template>
                <div slot="actions" slot-scope="props">
                    <button
                            class="btn btn-xs btn-primary"
                            @click="edit(props.row)">
                        <i class="fa fa-pencil-alt"></i>
                    </button>

                    <button
                            class="btn btn-xs btn-danger"
                            @click="destroy(props.row)">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </v-client-table>
        </card-body>
    </card>
</template>

<style lang="scss">
    .table tbody tr td:last-child {
        width: 1%;
        white-space: nowrap;
    }
</style>

<script>
    import TemplateChatForm from "./TemplateChatForm";

    export default {
        components: {TemplateChatForm},

        data   : () => ({
            columns  : ['name', 'text', 'locations', 'actions'],
            options  : {
                sortable  : ['name', 'text'],
                filterable: ['name', 'text'],
                headings  : {actions: ''}
            },
            templates: []
        }),
        created() {
            this.getTemplates();
        },
        methods: {
            getTemplates() {
                this.$http.get(this.$laroute.route('api.chat.template.index'))
                    .then(({data}) => {
                        this.templates = data.data;
                    });
            },

            create() {
                this.$refs.modalForm.open();
            },

            edit(item) {
                this.$refs.modalForm.open(item);
            },

            destroy(item) {
                let url = this.$laroute.route('api.chat.template.destroy', {template: item.id});

                this.$confirm().then(() => {
                    this.$http.delete(url).then(() => {
                        this.getTemplates();
                        this.$alert({
                            type   : 'success',
                            title  : 'Success!',
                            message: 'Template deleted'
                        });
                    })
                        .catch(() => {
                            this.$alert({
                                type   : 'error',
                                title  : 'Oops! Error deleting template',
                                message: 'Please try again or contact your system admin.'
                            });
                        });
                });
            },
        },
    };
</script>
